module.exports = __webpack_public_path__ + "img/tableImg.b51adcc9.jpg";